import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
import Authority from "../components/Authority/Authority";
import AboutSection from "../components/About/About";
import Challenges from "../components/Challenges/Challenges";
import Services from "../components/Services/Services";
import PlatformIntro from "../components/PlatformIntro/PlatformIntro";
import MembershipLevels from "../components/MembershipLevels/MembershipLevels";
import Testimonials from "../components/Testimonials/Testimonials";
import FAQ from "../components/FAQ/FAQ";
import BrandQuote from "../components/BrandQuote/BrandQuote";
import Stats from "../components/Stats/Stats";
import CTA from "../components/CTA/CTA";
import Footer from "../components/Footer/Footer";

const Home = () => {
  return (
    <div className="min-h-screen">
     <Helmet>
      <title>Mukesh Rathore | Independent Music Composer & Music Educator</title>
      <meta
          name="description"
          content="Mukesh Rathore is an independent Indian music composer and educator with 28+ years of experience. He helps first-time indie music creators compose, produce, and release their first original song through a structured mentorship process."
        />
      <meta
          property="og:title"
          content="Mukesh Rathore | Independent Music Composer & Music Educator"
        />
      <meta
          property="og:description"
          content="Independent Indian music composer and educator with 28+ years of experience, helping first-time indie music creators turn melodies into released songs."
        />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://mukeshrathore.com/" />
     </Helmet>
      <Navbar />
      <Hero />
      <Authority />
      <AboutSection />
      <Challenges />
      <Services />
      <PlatformIntro />
      <MembershipLevels />
      <Testimonials />
      <FAQ />
      <BrandQuote />
      <Stats />
      <CTA />
      <Footer />
    </div>
  );
};

export default Home;
